import { FormValues } from "./types";

export const INITIAL_VALUES: FormValues = {
  name: "",
  subject: "",
  body: "",
  hyperlink: "",
  audience: null,
  isObjectLevelBasicPermissionRole: false,
  isManageAdminConfigurationSettingRole: false,
  isManageStaffAccessSettingRole: false,
  isManageBasicSettingRole: false,
  investorManagerPrivileged: false,
  paymentAdmin: false,
  paymentManager: false,
  investorManagerPrivilegedViewonly: false,
  manageportalsettings: false,
  managegeneralsubscriptionsettings: false,
  managestaffaccess: false,
  manageuserroles: false,
  manageauthentication: false,
  manageagreements: false,
  managedatafields: false,
  accessauditlog: false,
  arenaType: null,
  expiryDate: undefined,
  isTestAnnouncement: false,
};
